import { Controller } from '@hotwired/stimulus'
import {
  groupByTimezone,
  isRowOpen,
  localDateKey,
  localWeekdayAndMs,
  scheduleLines,
  TICK_MS,
} from '~/lib/support_window'

export default class extends Controller {
  static targets = ['body']
  static values = { calendars: Array }

  connect() {
    this.groups = groupByTimezone(this.calendarsValue || [])

    if (this.groups.length === 0) {
      this.bodyTarget.innerHTML = `<span class="text-muted small">No support window data available</span>`
      return
    }

    this._render()
    this._tickInterval = setInterval(() => this._render(), TICK_MS)
  }

  disconnect() {
    clearInterval(this._tickInterval)
  }

  _render() {
    const now = new Date()

    this.bodyTarget.innerHTML = this.groups
      .map((group) => {
        const { weekday, ms, clock } = localWeekdayAndMs(group.timezone_id, now)
        const today = localDateKey(group.timezone_id, now)
        const open = group.rows.some((row) => isRowOpen(row, weekday, ms, today))
        const [firstLine, ...restLines] = scheduleLines(group.rows)

        return `
          <div class="d-flex flex-column gap-1">
            <div class="d-flex align-items-center gap-2">
              <span class="fw-medium">${group.timezone_id}</span>
              <span class="small fw-medium">${firstLine.schedule}</span>
              <span class="guardian-status-dot ${open ? 'bg-success' : 'bg-danger'} ms-auto" title="${open ? 'OPEN' : 'CLOSED'}"></span>
              <span class="small font-monospace text-muted">${clock}</span>
            </div>
            <span class="small text-muted d-block">${firstLine.names}</span>
            ${restLines
              .map(
                ({ schedule, names }) =>
                  `<span class="small d-block"><span class="fw-medium">${schedule}</span> <span class="text-muted">${names}</span></span>`,
              )
              .join('')}
          </div>
        `
      })
      .join('')
  }
}
